// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation BlockDeleteMutation( $input: BlockDeleteInput! ) {
		BlockDelete (input: $input) {
            error
        }
    }
`;
export function commit(environment: Environment, params: any, callback: (error: ?Error) => void) {
    console.log(params);
    commitMutation(
        environment,
        {
            mutation: mutation,
            variables: {
                input: params,
            },
			onCompleted: response => {
				const {error, id} = response.BlockDelete;
				if (error) {
					callback(error, null);
					return;
				}

				callback(null, id);
			},
            onError: (error) => {
                console.log("error mutating");
                console.log(error);
                callback(error, null);
            },
        },
    );
}



// WEBPACK FOOTER //
// src/mutations/BlockDeleteMutation.js